import { gql } from '@apollo/client';

export const FIND_DEPENDENCIES_BY_LOCATION_PROCESS_AREAS = gql`
  query FindDependenciesByLocation($locationUUID: ID!, $processAreaUUID: ID!) {
    findAll: findDependenciesByLocation(
      data: {
        locationUUID: { uuid: $locationUUID }
        processAreaUUID: { uuid: $processAreaUUID }
      }
    ) {
      intermediates {
        name
        procesessDependencys {
          comment
          percentage
          process
          processUUID
          supportedRevenue
          uuid
        }
        supportedRevenue
        key: uuid
      }
      name
      procesessDependencys {
        comment
        percentage
        process
        processUUID
        supportedRevenue
        uuid
      }
      children: productGroupFinancials {
        name
        procesessDependencys {
          comment
          percentage
          process
          processUUID
          supportedRevenue
          uuid
        }
        children: productFinancials {
          name
          procesessDependencys {
            comment
            percentage
            process
            processUUID
            supportedRevenue
            uuid
          }
          supportedRevenue
          key: uuid
        }
        supportedRevenue
        key: uuid
      }
      supportedRevenue
      key: uuid
    }
  }
`;

export const FIND_DEPENDENCIES_BY_LOCATION = gql`
  query FindDependenciesByLocation(
    $locationUUID: ID!
    $processAreaUUID: ID!
    $processUUID: ID!
  ) {
    findAll: findDependenciesByLocation(
      data: {
        locationUUID: { uuid: $locationUUID }
        processAreaUUID: { uuid: $processAreaUUID }
        processUUID: { uuid: $processUUID }
      }
    ) {
      intermediates {
        name
        procesessDependencys {
          comment
          percentage
          process
          processUUID
          supportedRevenue
          uuid
        }
        supportedRevenue
        key: uuid
      }
      name
      procesessDependencys {
        comment
        percentage
        process
        processUUID
        supportedRevenue
        uuid
      }
      children: productGroupFinancials {
        name
        procesessDependencys {
          comment
          percentage
          process
          processUUID
          supportedRevenue
          uuid
        }
        children: productFinancials {
          name
          procesessDependencys {
            comment
            percentage
            process
            processUUID
            supportedRevenue
            uuid
          }
          supportedRevenue
          key: uuid
        }
        supportedRevenue
        key: uuid
      }
      supportedRevenue
      key: uuid
    }
  }
`;

export const UPSERT_MULTIPLE_PROCESS_DEPENDENCY = gql`
  mutation UpsertMultipleProcessDependency(
    $data: UpsertMultipleProcessDependencyInput!
  ) {
    upsertMultipleProcessDependency(data: $data) {
      process
      processDependency {
        comment
        percentage
        supportedRevenue
        uuid
      }
      processUUID
    }
  }
`;

export const UPDATE_PROCESSES_MUTATION = gql`
  mutation UpdateProcesses($data: UpdateProcessesInput!) {
    updateProcesses(data: $data) {
      comment
      process
      replacementCost
      replacementTime
      uuid
    }
  }
`;
